function c(e, t, n) {
  function r(s, a) {
    var h;
    Object.defineProperty(s, "_zod", {
      value: s._zod ?? {},
      enumerable: !1
    }), (h = s._zod).traits ?? (h.traits = /* @__PURE__ */ new Set()), s._zod.traits.add(e), t(s, a);
    for (const _ in i.prototype)
      _ in s || Object.defineProperty(s, _, { value: i.prototype[_].bind(s) });
    s._zod.constr = i, s._zod.def = a;
  }
  const o = (n == null ? void 0 : n.Parent) ?? Object;
  class u extends o {
  }
  Object.defineProperty(u, "name", { value: e });
  function i(s) {
    var a;
    const h = n != null && n.Parent ? new u() : this;
    r(h, s), (a = h._zod).deferred ?? (a.deferred = []);
    for (const _ of h._zod.deferred)
      _();
    return h;
  }
  return Object.defineProperty(i, "init", { value: r }), Object.defineProperty(i, Symbol.hasInstance, {
    value: (s) => {
      var a, h;
      return n != null && n.Parent && s instanceof n.Parent ? !0 : (h = (a = s == null ? void 0 : s._zod) == null ? void 0 : a.traits) == null ? void 0 : h.has(e);
    }
  }), Object.defineProperty(i, "name", { value: e }), i;
}
class j extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
const Se = {};
function P(e) {
  return Se;
}
function Qe(e) {
  const t = Object.values(e).filter((r) => typeof r == "number");
  return Object.entries(e).filter(([r, o]) => t.indexOf(+r) === -1).map(([r, o]) => o);
}
function et(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Ae(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function oe(e) {
  return e == null;
}
function ue(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function tt(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, o = n > r ? n : r, u = Number.parseInt(e.toFixed(o).replace(".", "")), i = Number.parseInt(t.toFixed(o).replace(".", ""));
  return u % i / 10 ** o;
}
function v(e, t, n) {
  Object.defineProperty(e, t, {
    get() {
      {
        const r = n();
        return e[t] = r, r;
      }
    },
    set(r) {
      Object.defineProperty(e, t, {
        value: r
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function ie(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function x(e) {
  return JSON.stringify(e);
}
const Ne = Error.captureStackTrace ? Error.captureStackTrace : (...e) => {
};
function te(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const nt = Ae(() => {
  var e;
  if (typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) != null && e.includes("Cloudflare")))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function G(e) {
  if (te(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(te(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
const rt = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Y(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function A(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n != null && n.parent) && (r._zod.parent = e), r;
}
function l(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if ((t == null ? void 0 : t.message) !== void 0) {
    if ((t == null ? void 0 : t.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function ot(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const ut = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function it(e, t) {
  const n = {}, r = e._zod.def;
  for (const o in t) {
    if (!(o in r.shape))
      throw new Error(`Unrecognized key: "${o}"`);
    t[o] && (n[o] = r.shape[o]);
  }
  return A(e, {
    ...e._zod.def,
    shape: n,
    checks: []
  });
}
function ct(e, t) {
  const n = { ...e._zod.def.shape }, r = e._zod.def;
  for (const o in t) {
    if (!(o in r.shape))
      throw new Error(`Unrecognized key: "${o}"`);
    t[o] && delete n[o];
  }
  return A(e, {
    ...e._zod.def,
    shape: n,
    checks: []
  });
}
function st(e, t) {
  if (!G(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = {
    ...e._zod.def,
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return ie(this, "shape", r), r;
    },
    checks: []
    // delete existing checks
  };
  return A(e, n);
}
function at(e, t) {
  return A(e, {
    ...e._zod.def,
    get shape() {
      const n = { ...e._zod.def.shape, ...t._zod.def.shape };
      return ie(this, "shape", n), n;
    },
    catchall: t._zod.def.catchall,
    checks: []
    // delete existing checks
  });
}
function lt(e, t, n) {
  const r = t._zod.def.shape, o = { ...r };
  if (n)
    for (const u in n) {
      if (!(u in r))
        throw new Error(`Unrecognized key: "${u}"`);
      n[u] && (o[u] = e ? new e({
        type: "optional",
        innerType: r[u]
      }) : r[u]);
    }
  else
    for (const u in r)
      o[u] = e ? new e({
        type: "optional",
        innerType: r[u]
      }) : r[u];
  return A(t, {
    ...t._zod.def,
    shape: o,
    checks: []
  });
}
function ht(e, t, n) {
  const r = t._zod.def.shape, o = { ...r };
  if (n)
    for (const u in n) {
      if (!(u in o))
        throw new Error(`Unrecognized key: "${u}"`);
      n[u] && (o[u] = new e({
        type: "nonoptional",
        innerType: r[u]
      }));
    }
  else
    for (const u in r)
      o[u] = new e({
        type: "nonoptional",
        innerType: r[u]
      });
  return A(t, {
    ...t._zod.def,
    shape: o,
    // optional: [],
    checks: []
  });
}
function C(e, t = 0) {
  var n;
  for (let r = t; r < e.issues.length; r++)
    if (((n = e.issues[r]) == null ? void 0 : n.continue) !== !0)
      return !0;
  return !1;
}
function S(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function M(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function O(e, t, n) {
  var o, u, i, s, a, h;
  const r = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const _ = M((i = (u = (o = e.inst) == null ? void 0 : o._zod.def) == null ? void 0 : u.error) == null ? void 0 : i.call(u, e)) ?? M((s = t == null ? void 0 : t.error) == null ? void 0 : s.call(t, e)) ?? M((a = n.customError) == null ? void 0 : a.call(n, e)) ?? M((h = n.localeError) == null ? void 0 : h.call(n, e)) ?? "Invalid input";
    r.message = _;
  }
  return delete r.inst, delete r.continue, t != null && t.reportInput || delete r.input, r;
}
function ce(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function D(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const Re = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), Object.defineProperty(e, "message", {
    get() {
      return JSON.stringify(t, et, 2);
    },
    enumerable: !0
    // configurable: false,
  }), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, xe = c("$ZodError", Re), Ce = c("$ZodError", Re, { Parent: Error });
function pt(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const o of e.issues)
    o.path.length > 0 ? (n[o.path[0]] = n[o.path[0]] || [], n[o.path[0]].push(t(o))) : r.push(t(o));
  return { formErrors: r, fieldErrors: n };
}
function ft(e, t) {
  const n = t || function(u) {
    return u.message;
  }, r = { _errors: [] }, o = (u) => {
    for (const i of u.issues)
      if (i.code === "invalid_union" && i.errors.length)
        i.errors.map((s) => o({ issues: s }));
      else if (i.code === "invalid_key")
        o({ issues: i.issues });
      else if (i.code === "invalid_element")
        o({ issues: i.issues });
      else if (i.path.length === 0)
        r._errors.push(n(i));
      else {
        let s = r, a = 0;
        for (; a < i.path.length; ) {
          const h = i.path[a];
          a === i.path.length - 1 ? (s[h] = s[h] || { _errors: [] }, s[h]._errors.push(n(i))) : s[h] = s[h] || { _errors: [] }, s = s[h], a++;
        }
      }
  };
  return o(e), r;
}
const dt = (e) => (t, n, r, o) => {
  const u = r ? Object.assign(r, { async: !1 }) : { async: !1 }, i = t._zod.run({ value: n, issues: [] }, u);
  if (i instanceof Promise)
    throw new j();
  if (i.issues.length) {
    const s = new ((o == null ? void 0 : o.Err) ?? e)(i.issues.map((a) => O(a, u, P())));
    throw Ne(s, o == null ? void 0 : o.callee), s;
  }
  return i.value;
}, _t = (e) => async (t, n, r, o) => {
  const u = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let i = t._zod.run({ value: n, issues: [] }, u);
  if (i instanceof Promise && (i = await i), i.issues.length) {
    const s = new ((o == null ? void 0 : o.Err) ?? e)(i.issues.map((a) => O(a, u, P())));
    throw Ne(s, o == null ? void 0 : o.callee), s;
  }
  return i.value;
}, je = (e) => (t, n, r) => {
  const o = r ? { ...r, async: !1 } : { async: !1 }, u = t._zod.run({ value: n, issues: [] }, o);
  if (u instanceof Promise)
    throw new j();
  return u.issues.length ? {
    success: !1,
    error: new (e ?? xe)(u.issues.map((i) => O(i, o, P())))
  } : { success: !0, data: u.value };
}, mt = /* @__PURE__ */ je(Ce), De = (e) => async (t, n, r) => {
  const o = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let u = t._zod.run({ value: n, issues: [] }, o);
  return u instanceof Promise && (u = await u), u.issues.length ? {
    success: !1,
    error: new e(u.issues.map((i) => O(i, o, P())))
  } : { success: !0, data: u.value };
}, vt = /* @__PURE__ */ De(Ce), gt = /^[cC][^\s-]{8,}$/, zt = /^[0-9a-z]+$/, bt = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, wt = /^[0-9a-vA-V]{20}$/, Zt = /^[A-Za-z0-9]{27}$/, kt = /^[a-zA-Z0-9_-]{21}$/, $t = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, yt = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, he = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000)$/, It = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Et = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function Tt() {
  return new RegExp(Et, "u");
}
const Pt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Ot = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})$/, St = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, At = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Nt = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, Ue = /^[A-Za-z0-9_-]*$/, Rt = /^([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+$/, xt = /^\+(?:[0-9]){6,14}[0-9]$/, Fe = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Ct = /* @__PURE__ */ new RegExp(`^${Fe}$`);
function Le(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function jt(e) {
  return new RegExp(`^${Le(e)}$`);
}
function Dt(e) {
  const t = Le({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-]\\d{2}:\\d{2})");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${Fe}T(?:${r})$`);
}
const Ut = (e) => {
  const t = e ? `[\\s\\S]{${(e == null ? void 0 : e.minimum) ?? 0},${(e == null ? void 0 : e.maximum) ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Ft = /^\d+$/, Lt = /^-?\d+(?:\.\d+)?/i, Mt = /true|false/i, Vt = /^[^A-Z]*$/, Wt = /^[^a-z]*$/, I = /* @__PURE__ */ c("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), Me = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, Ve = /* @__PURE__ */ c("$ZodCheckLessThan", (e, t) => {
  I.init(e, t);
  const n = Me[typeof t.value];
  e._zod.onattach.push((r) => {
    const o = r._zod.bag, u = (t.inclusive ? o.maximum : o.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < u && (t.inclusive ? o.maximum = t.value : o.exclusiveMaximum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
      origin: n,
      code: "too_big",
      maximum: t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), We = /* @__PURE__ */ c("$ZodCheckGreaterThan", (e, t) => {
  I.init(e, t);
  const n = Me[typeof t.value];
  e._zod.onattach.push((r) => {
    const o = r._zod.bag, u = (t.inclusive ? o.minimum : o.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > u && (t.inclusive ? o.minimum = t.value : o.exclusiveMinimum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
      origin: n,
      code: "too_small",
      minimum: t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Bt = /* @__PURE__ */ c("$ZodCheckMultipleOf", (e, t) => {
  I.init(e, t), e._zod.onattach.push((n) => {
    var r;
    (r = n._zod.bag).multipleOf ?? (r.multipleOf = t.value);
  }), e._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : tt(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Gt = /* @__PURE__ */ c("$ZodCheckNumberFormat", (e, t) => {
  var i;
  I.init(e, t), t.format = t.format || "float64";
  const n = (i = t.format) == null ? void 0 : i.includes("int"), r = n ? "int" : "number", [o, u] = ut[t.format];
  e._zod.onattach.push((s) => {
    const a = s._zod.bag;
    a.format = t.format, a.minimum = o, a.maximum = u, n && (a.pattern = Ft);
  }), e._zod.check = (s) => {
    const a = s.value;
    if (n) {
      if (!Number.isInteger(a)) {
        s.issues.push({
          expected: r,
          format: t.format,
          code: "invalid_type",
          input: a,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(a)) {
        a > 0 ? s.issues.push({
          input: a,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: r,
          continue: !t.abort
        }) : s.issues.push({
          input: a,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: r,
          continue: !t.abort
        });
        return;
      }
    }
    a < o && s.issues.push({
      origin: "number",
      input: a,
      code: "too_small",
      minimum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), a > u && s.issues.push({
      origin: "number",
      input: a,
      code: "too_big",
      maximum: u,
      inst: e
    });
  };
}), Kt = /* @__PURE__ */ c("$ZodCheckMaxLength", (e, t) => {
  var n;
  I.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const o = r.value;
    return !oe(o) && o.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const o = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < o && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const o = r.value;
    if (o.length <= t.maximum)
      return;
    const i = ce(o);
    r.issues.push({
      origin: i,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: o,
      inst: e,
      continue: !t.abort
    });
  };
}), Jt = /* @__PURE__ */ c("$ZodCheckMinLength", (e, t) => {
  var n;
  I.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const o = r.value;
    return !oe(o) && o.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const o = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > o && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const o = r.value;
    if (o.length >= t.minimum)
      return;
    const i = ce(o);
    r.issues.push({
      origin: i,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: o,
      inst: e,
      continue: !t.abort
    });
  };
}), Yt = /* @__PURE__ */ c("$ZodCheckLengthEquals", (e, t) => {
  var n;
  I.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const o = r.value;
    return !oe(o) && o.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.minimum = t.length, o.maximum = t.length, o.length = t.length;
  }), e._zod.check = (r) => {
    const o = r.value, u = o.length;
    if (u === t.length)
      return;
    const i = ce(o), s = u > t.length;
    r.issues.push({
      origin: i,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), X = /* @__PURE__ */ c("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  I.init(e, t), e._zod.onattach.push((o) => {
    const u = o._zod.bag;
    u.format = t.format, t.pattern && (u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (o) => {
    t.pattern.lastIndex = 0, !t.pattern.test(o.value) && o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: o.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), Xt = /* @__PURE__ */ c("$ZodCheckRegex", (e, t) => {
  X.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), qt = /* @__PURE__ */ c("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Vt), X.init(e, t);
}), Ht = /* @__PURE__ */ c("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = Wt), X.init(e, t);
}), Qt = /* @__PURE__ */ c("$ZodCheckIncludes", (e, t) => {
  I.init(e, t);
  const n = Y(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((o) => {
    const u = o._zod.bag;
    u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(r);
  }), e._zod.check = (o) => {
    o.value.includes(t.includes, t.position) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), en = /* @__PURE__ */ c("$ZodCheckStartsWith", (e, t) => {
  I.init(e, t);
  const n = new RegExp(`^${Y(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), tn = /* @__PURE__ */ c("$ZodCheckEndsWith", (e, t) => {
  I.init(e, t);
  const n = new RegExp(`.*${Y(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), nn = /* @__PURE__ */ c("$ZodCheckOverwrite", (e, t) => {
  I.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class rn {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const r = t.split(`
`).filter((i) => i), o = Math.min(...r.map((i) => i.length - i.trimStart().length)), u = r.map((i) => i.slice(o)).map((i) => " ".repeat(this.indent * 2) + i);
    for (const i of u)
      this.content.push(i);
  }
  compile() {
    const t = Function, n = this == null ? void 0 : this.args, o = [...((this == null ? void 0 : this.content) ?? [""]).map((u) => `  ${u}`)];
    return new t(...n, o.join(`
`));
  }
}
const on = {
  major: 4,
  minor: 0,
  patch: 0
}, b = /* @__PURE__ */ c("$ZodType", (e, t) => {
  var o;
  var n;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = on;
  const r = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && r.unshift(e);
  for (const u of r)
    for (const i of u._zod.onattach)
      i(e);
  if (r.length === 0)
    (n = e._zod).deferred ?? (n.deferred = []), (o = e._zod.deferred) == null || o.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const u = (i, s, a) => {
      let h = C(i), _;
      for (const p of s) {
        if (p._zod.def.when) {
          if (!p._zod.def.when(i))
            continue;
        } else if (h)
          continue;
        const f = i.issues.length, m = p._zod.check(i);
        if (m instanceof Promise && (a == null ? void 0 : a.async) === !1)
          throw new j();
        if (_ || m instanceof Promise)
          _ = (_ ?? Promise.resolve()).then(async () => {
            await m, i.issues.length !== f && (h || (h = C(i, f)));
          });
        else {
          if (i.issues.length === f)
            continue;
          h || (h = C(i, f));
        }
      }
      return _ ? _.then(() => i) : i;
    };
    e._zod.run = (i, s) => {
      const a = e._zod.parse(i, s);
      if (a instanceof Promise) {
        if (s.async === !1)
          throw new j();
        return a.then((h) => u(h, r, s));
      }
      return u(a, r, s);
    };
  }
  e["~standard"] = {
    validate: (u) => {
      var i;
      try {
        const s = mt(e, u);
        return s.success ? { value: s.data } : { issues: (i = s.error) == null ? void 0 : i.issues };
      } catch {
        return vt(e, u).then((a) => {
          var h;
          return a.success ? { value: a.data } : { issues: (h = a.error) == null ? void 0 : h.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  };
}), se = /* @__PURE__ */ c("$ZodString", (e, t) => {
  var n;
  b.init(e, t), e._zod.pattern = [...((n = e == null ? void 0 : e._zod.bag) == null ? void 0 : n.patterns) ?? []].pop() ?? Ut(e._zod.bag), e._zod.parse = (r, o) => {
    if (t.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), g = /* @__PURE__ */ c("$ZodStringFormat", (e, t) => {
  X.init(e, t), se.init(e, t);
}), un = /* @__PURE__ */ c("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = yt), g.init(e, t);
}), cn = /* @__PURE__ */ c("$ZodUUID", (e, t) => {
  if (t.version) {
    const r = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (r === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = he(r));
  } else
    t.pattern ?? (t.pattern = he());
  g.init(e, t);
}), sn = /* @__PURE__ */ c("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = It), g.init(e, t);
}), an = /* @__PURE__ */ c("$ZodURL", (e, t) => {
  g.init(e, t), e._zod.check = (n) => {
    try {
      const r = n.value, o = new URL(r), u = o.href;
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(o.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: Rt.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(o.protocol.endsWith(":") ? o.protocol.slice(0, -1) : o.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), !r.endsWith("/") && u.endsWith("/") ? n.value = u.slice(0, -1) : n.value = u;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), ln = /* @__PURE__ */ c("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = Tt()), g.init(e, t);
}), hn = /* @__PURE__ */ c("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = kt), g.init(e, t);
}), pn = /* @__PURE__ */ c("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = gt), g.init(e, t);
}), fn = /* @__PURE__ */ c("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = zt), g.init(e, t);
}), dn = /* @__PURE__ */ c("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = bt), g.init(e, t);
}), _n = /* @__PURE__ */ c("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = wt), g.init(e, t);
}), mn = /* @__PURE__ */ c("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = Zt), g.init(e, t);
}), vn = /* @__PURE__ */ c("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = Dt(t)), g.init(e, t);
}), gn = /* @__PURE__ */ c("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = Ct), g.init(e, t);
}), zn = /* @__PURE__ */ c("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = jt(t)), g.init(e, t);
}), bn = /* @__PURE__ */ c("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = $t), g.init(e, t);
}), wn = /* @__PURE__ */ c("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = Pt), g.init(e, t), e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.format = "ipv4";
  });
}), Zn = /* @__PURE__ */ c("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = Ot), g.init(e, t), e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.format = "ipv6";
  }), e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), kn = /* @__PURE__ */ c("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = St), g.init(e, t);
}), $n = /* @__PURE__ */ c("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = At), g.init(e, t), e._zod.check = (n) => {
    const [r, o] = n.value.split("/");
    try {
      if (!o)
        throw new Error();
      const u = Number(o);
      if (`${u}` !== o)
        throw new Error();
      if (u < 0 || u > 128)
        throw new Error();
      new URL(`http://[${r}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function Be(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const yn = /* @__PURE__ */ c("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = Nt), g.init(e, t), e._zod.onattach.push((n) => {
    n._zod.bag.contentEncoding = "base64";
  }), e._zod.check = (n) => {
    Be(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function In(e) {
  if (!Ue.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Be(n);
}
const En = /* @__PURE__ */ c("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = Ue), g.init(e, t), e._zod.onattach.push((n) => {
    n._zod.bag.contentEncoding = "base64url";
  }), e._zod.check = (n) => {
    In(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Tn = /* @__PURE__ */ c("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = xt), g.init(e, t);
});
function Pn(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const o = JSON.parse(atob(r));
    return !("typ" in o && (o == null ? void 0 : o.typ) !== "JWT" || !o.alg || t && (!("alg" in o) || o.alg !== t));
  } catch {
    return !1;
  }
}
const On = /* @__PURE__ */ c("$ZodJWT", (e, t) => {
  g.init(e, t), e._zod.check = (n) => {
    Pn(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Ge = /* @__PURE__ */ c("$ZodNumber", (e, t) => {
  b.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? Lt, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const o = n.value;
    if (typeof o == "number" && !Number.isNaN(o) && Number.isFinite(o))
      return n;
    const u = typeof o == "number" ? Number.isNaN(o) ? "NaN" : Number.isFinite(o) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: o,
      inst: e,
      ...u ? { received: u } : {}
    }), n;
  };
}), Sn = /* @__PURE__ */ c("$ZodNumber", (e, t) => {
  Gt.init(e, t), Ge.init(e, t);
}), An = /* @__PURE__ */ c("$ZodBoolean", (e, t) => {
  b.init(e, t), e._zod.pattern = Mt, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = !!n.value;
      } catch {
      }
    const o = n.value;
    return typeof o == "boolean" || n.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: o,
      inst: e
    }), n;
  };
}), Nn = /* @__PURE__ */ c("$ZodUnknown", (e, t) => {
  b.init(e, t), e._zod.parse = (n) => n;
}), Rn = /* @__PURE__ */ c("$ZodNever", (e, t) => {
  b.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function pe(e, t, n) {
  e.issues.length && t.issues.push(...S(n, e.issues)), t.value[n] = e.value;
}
const xn = /* @__PURE__ */ c("$ZodArray", (e, t) => {
  b.init(e, t), e._zod.parse = (n, r) => {
    const o = n.value;
    if (!Array.isArray(o))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: o,
        inst: e
      }), n;
    n.value = Array(o.length);
    const u = [];
    for (let i = 0; i < o.length; i++) {
      const s = o[i], a = t.element._zod.run({
        value: s,
        issues: []
      }, r);
      a instanceof Promise ? u.push(a.then((h) => pe(h, n, i))) : pe(a, n, i);
    }
    return u.length ? Promise.all(u).then(() => n) : n;
  };
});
function V(e, t, n) {
  e.issues.length && t.issues.push(...S(n, e.issues)), t.value[n] = e.value;
}
function fe(e, t, n, r) {
  e.issues.length ? r[n] === void 0 ? n in r ? t.value[n] = void 0 : t.value[n] = e.value : t.issues.push(...S(n, e.issues)) : e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
const Cn = /* @__PURE__ */ c("$ZodObject", (e, t) => {
  b.init(e, t);
  const n = Ae(() => {
    const p = Object.keys(t.shape);
    for (const m of p)
      if (!(t.shape[m] instanceof b))
        throw new Error(`Invalid element at key "${m}": expected a Zod schema`);
    const f = ot(t.shape);
    return {
      shape: t.shape,
      keys: p,
      keySet: new Set(p),
      numKeys: p.length,
      optionalKeys: new Set(f)
    };
  });
  v(e._zod, "propValues", () => {
    const p = t.shape, f = {};
    for (const m in p) {
      const y = p[m]._zod;
      if (y.values) {
        f[m] ?? (f[m] = /* @__PURE__ */ new Set());
        for (const E of y.values)
          f[m].add(E);
      }
    }
    return f;
  });
  const r = (p) => {
    const f = new rn(["shape", "payload", "ctx"]), m = n.value, y = ($) => {
      const z = x($);
      return `shape[${z}]._zod.run({ value: input[${z}], issues: [] }, ctx)`;
    };
    f.write("const input = payload.value;");
    const E = /* @__PURE__ */ Object.create(null);
    let H = 0;
    for (const $ of m.keys)
      E[$] = `key_${H++}`;
    f.write("const newResult = {}");
    for (const $ of m.keys)
      if (m.optionalKeys.has($)) {
        const z = E[$];
        f.write(`const ${z} = ${y($)};`);
        const k = x($);
        f.write(`
        if (${z}.issues.length) {
          if (input[${k}] === undefined) {
            if (${k} in input) {
              newResult[${k}] = undefined;
            }
          } else {
            payload.issues = payload.issues.concat(
              ${z}.issues.map((iss) => ({
                ...iss,
                path: iss.path ? [${k}, ...iss.path] : [${k}],
              }))
            );
          }
        } else if (${z}.value === undefined) {
          if (${k} in input) newResult[${k}] = undefined;
        } else {
          newResult[${k}] = ${z}.value;
        }
        `);
      } else {
        const z = E[$];
        f.write(`const ${z} = ${y($)};`), f.write(`
          if (${z}.issues.length) payload.issues = payload.issues.concat(${z}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${x($)}, ...iss.path] : [${x($)}]
          })));`), f.write(`newResult[${x($)}] = ${z}.value`);
      }
    f.write("payload.value = newResult;"), f.write("return payload;");
    const F = f.compile();
    return ($, z) => F(p, $, z);
  };
  let o;
  const u = te, i = !Se.jitless, a = i && nt.value, h = t.catchall;
  let _;
  e._zod.parse = (p, f) => {
    _ ?? (_ = n.value);
    const m = p.value;
    if (!u(m))
      return p.issues.push({
        expected: "object",
        code: "invalid_type",
        input: m,
        inst: e
      }), p;
    const y = [];
    if (i && a && (f == null ? void 0 : f.async) === !1 && f.jitless !== !0)
      o || (o = r(t.shape)), p = o(p, f);
    else {
      p.value = {};
      const z = _.shape;
      for (const k of _.keys) {
        const R = z[k], L = R._zod.run({ value: m[k], issues: [] }, f), ae = R._zod.optin === "optional" && R._zod.optout === "optional";
        L instanceof Promise ? y.push(L.then((le) => ae ? fe(le, p, k, m) : V(le, p, k))) : ae ? fe(L, p, k, m) : V(L, p, k);
      }
    }
    if (!h)
      return y.length ? Promise.all(y).then(() => p) : p;
    const E = [], H = _.keySet, F = h._zod, $ = F.def.type;
    for (const z of Object.keys(m)) {
      if (H.has(z))
        continue;
      if ($ === "never") {
        E.push(z);
        continue;
      }
      const k = F.run({ value: m[z], issues: [] }, f);
      k instanceof Promise ? y.push(k.then((R) => V(R, p, z))) : V(k, p, z);
    }
    return E.length && p.issues.push({
      code: "unrecognized_keys",
      keys: E,
      input: m,
      inst: e
    }), y.length ? Promise.all(y).then(() => p) : p;
  };
});
function de(e, t, n, r) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  return t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((o) => o.issues.map((u) => O(u, r, P())))
  }), t;
}
const jn = /* @__PURE__ */ c("$ZodUnion", (e, t) => {
  b.init(e, t), v(e._zod, "optin", () => t.options.some((n) => n._zod.optin === "optional") ? "optional" : void 0), v(e._zod, "optout", () => t.options.some((n) => n._zod.optout === "optional") ? "optional" : void 0), v(e._zod, "values", () => {
    if (t.options.every((n) => n._zod.values))
      return new Set(t.options.flatMap((n) => Array.from(n._zod.values)));
  }), v(e._zod, "pattern", () => {
    if (t.options.every((n) => n._zod.pattern)) {
      const n = t.options.map((r) => r._zod.pattern);
      return new RegExp(`^(${n.map((r) => ue(r.source)).join("|")})$`);
    }
  }), e._zod.parse = (n, r) => {
    let o = !1;
    const u = [];
    for (const i of t.options) {
      const s = i._zod.run({
        value: n.value,
        issues: []
      }, r);
      if (s instanceof Promise)
        u.push(s), o = !0;
      else {
        if (s.issues.length === 0)
          return s;
        u.push(s);
      }
    }
    return o ? Promise.all(u).then((i) => de(i, n, e, r)) : de(u, n, e, r);
  };
}), Dn = /* @__PURE__ */ c("$ZodIntersection", (e, t) => {
  b.init(e, t), e._zod.parse = (n, r) => {
    const o = n.value, u = t.left._zod.run({ value: o, issues: [] }, r), i = t.right._zod.run({ value: o, issues: [] }, r);
    return u instanceof Promise || i instanceof Promise ? Promise.all([u, i]).then(([a, h]) => _e(n, a, h)) : _e(n, u, i);
  };
});
function ne(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (G(e) && G(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((u) => n.indexOf(u) !== -1), o = { ...e, ...t };
    for (const u of r) {
      const i = ne(e[u], t[u]);
      if (!i.valid)
        return {
          valid: !1,
          mergeErrorPath: [u, ...i.mergeErrorPath]
        };
      o[u] = i.data;
    }
    return { valid: !0, data: o };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const o = e[r], u = t[r], i = ne(o, u);
      if (!i.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...i.mergeErrorPath]
        };
      n.push(i.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function _e(e, t, n) {
  if (t.issues.length && e.issues.push(...t.issues), n.issues.length && e.issues.push(...n.issues), C(e))
    return e;
  const r = ne(t.value, n.value);
  if (!r.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(r.mergeErrorPath)}`);
  return e.value = r.data, e;
}
const Un = /* @__PURE__ */ c("$ZodRecord", (e, t) => {
  b.init(e, t), e._zod.parse = (n, r) => {
    const o = n.value;
    if (!G(o))
      return n.issues.push({
        expected: "record",
        code: "invalid_type",
        input: o,
        inst: e
      }), n;
    const u = [];
    if (t.keyType._zod.values) {
      const i = t.keyType._zod.values;
      n.value = {};
      for (const a of i)
        if (typeof a == "string" || typeof a == "number" || typeof a == "symbol") {
          const h = t.valueType._zod.run({ value: o[a], issues: [] }, r);
          h instanceof Promise ? u.push(h.then((_) => {
            _.issues.length && n.issues.push(...S(a, _.issues)), n.value[a] = _.value;
          })) : (h.issues.length && n.issues.push(...S(a, h.issues)), n.value[a] = h.value);
        }
      let s;
      for (const a in o)
        i.has(a) || (s = s ?? [], s.push(a));
      s && s.length > 0 && n.issues.push({
        code: "unrecognized_keys",
        input: o,
        inst: e,
        keys: s
      });
    } else {
      n.value = {};
      for (const i of Reflect.ownKeys(o)) {
        if (i === "__proto__")
          continue;
        const s = t.keyType._zod.run({ value: i, issues: [] }, r);
        if (s instanceof Promise)
          throw new Error("Async schemas not supported in object keys currently");
        if (s.issues.length) {
          n.issues.push({
            origin: "record",
            code: "invalid_key",
            issues: s.issues.map((h) => O(h, r, P())),
            input: i,
            path: [i],
            inst: e
          }), n.value[s.value] = s.value;
          continue;
        }
        const a = t.valueType._zod.run({ value: o[i], issues: [] }, r);
        a instanceof Promise ? u.push(a.then((h) => {
          h.issues.length && n.issues.push(...S(i, h.issues)), n.value[s.value] = h.value;
        })) : (a.issues.length && n.issues.push(...S(i, a.issues)), n.value[s.value] = a.value);
      }
    }
    return u.length ? Promise.all(u).then(() => n) : n;
  };
}), Fn = /* @__PURE__ */ c("$ZodEnum", (e, t) => {
  b.init(e, t);
  const n = Qe(t.entries);
  e._zod.values = new Set(n), e._zod.pattern = new RegExp(`^(${n.filter((r) => rt.has(typeof r)).map((r) => typeof r == "string" ? Y(r) : r.toString()).join("|")})$`), e._zod.parse = (r, o) => {
    const u = r.value;
    return e._zod.values.has(u) || r.issues.push({
      code: "invalid_value",
      values: n,
      input: u,
      inst: e
    }), r;
  };
}), Ln = /* @__PURE__ */ c("$ZodTransform", (e, t) => {
  b.init(e, t), e._zod.parse = (n, r) => {
    const o = t.transform(n.value, n);
    if (r.async)
      return (o instanceof Promise ? o : Promise.resolve(o)).then((i) => (n.value = i, n));
    if (o instanceof Promise)
      throw new j();
    return n.value = o, n;
  };
}), Mn = /* @__PURE__ */ c("$ZodOptional", (e, t) => {
  b.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", v(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), v(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${ue(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => t.innerType._zod.optin === "optional" ? t.innerType._zod.run(n, r) : n.value === void 0 ? n : t.innerType._zod.run(n, r);
}), Vn = /* @__PURE__ */ c("$ZodNullable", (e, t) => {
  b.init(e, t), v(e._zod, "optin", () => t.innerType._zod.optin), v(e._zod, "optout", () => t.innerType._zod.optout), v(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${ue(n.source)}|null)$`) : void 0;
  }), v(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), Wn = /* @__PURE__ */ c("$ZodDefault", (e, t) => {
  b.init(e, t), e._zod.optin = "optional", v(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((u) => me(u, t)) : me(o, t);
  };
});
function me(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Bn = /* @__PURE__ */ c("$ZodPrefault", (e, t) => {
  b.init(e, t), e._zod.optin = "optional", v(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), Gn = /* @__PURE__ */ c("$ZodNonOptional", (e, t) => {
  b.init(e, t), v(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((u) => ve(u, e)) : ve(o, e);
  };
});
function ve(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const Kn = /* @__PURE__ */ c("$ZodCatch", (e, t) => {
  b.init(e, t), e._zod.optin = "optional", v(e._zod, "optout", () => t.innerType._zod.optout), v(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((u) => (n.value = u.value, u.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: u.issues.map((i) => O(i, r, P()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = o.value, o.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: o.issues.map((u) => O(u, r, P()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), Jn = /* @__PURE__ */ c("$ZodPipe", (e, t) => {
  b.init(e, t), v(e._zod, "values", () => t.in._zod.values), v(e._zod, "optin", () => t.in._zod.optin), v(e._zod, "optout", () => t.out._zod.optout), e._zod.parse = (n, r) => {
    const o = t.in._zod.run(n, r);
    return o instanceof Promise ? o.then((u) => ge(u, t, r)) : ge(o, t, r);
  };
});
function ge(e, t, n) {
  return C(e) ? e : t.out._zod.run({ value: e.value, issues: e.issues }, n);
}
const Yn = /* @__PURE__ */ c("$ZodReadonly", (e, t) => {
  b.init(e, t), v(e._zod, "propValues", () => t.innerType._zod.propValues), v(e._zod, "values", () => t.innerType._zod.values), v(e._zod, "optin", () => t.innerType._zod.optin), v(e._zod, "optout", () => t.innerType._zod.optout), e._zod.parse = (n, r) => {
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then(ze) : ze(o);
  };
});
function ze(e) {
  return e.value = Object.freeze(e.value), e;
}
const Xn = /* @__PURE__ */ c("$ZodCustom", (e, t) => {
  I.init(e, t), b.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, o = t.fn(r);
    if (o instanceof Promise)
      return o.then((u) => be(u, n, r, e));
    be(o, n, r, e);
  };
});
function be(e, t, n, r) {
  if (!e) {
    const o = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (o.params = r._zod.def.params), t.issues.push(D(o));
  }
}
class qn {
  constructor() {
    this._map = /* @__PURE__ */ new Map(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    if (this._map.set(t, r), r && typeof r == "object" && "id" in r) {
      if (this._idmap.has(r.id))
        throw new Error(`ID ${r.id} already exists in the registry`);
      this._idmap.set(r.id, t);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new Map(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      return delete r.id, { ...r, ...this._map.get(t) };
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function Hn() {
  return new qn();
}
const W = /* @__PURE__ */ Hn();
function Qn(e, t) {
  return new e({
    type: "string",
    ...l(t)
  });
}
function er(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function we(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function tr(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function nr(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...l(t)
  });
}
function rr(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...l(t)
  });
}
function or(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...l(t)
  });
}
function ur(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function ir(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function cr(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function sr(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function ar(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function lr(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function hr(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function pr(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function fr(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function dr(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function _r(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function mr(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function vr(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function gr(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function zr(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function br(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function wr(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...l(t)
  });
}
function Zr(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...l(t)
  });
}
function kr(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...l(t)
  });
}
function $r(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...l(t)
  });
}
function yr(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...l(t)
  });
}
function Ir(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...l(t)
  });
}
function Er(e, t) {
  return new e({
    type: "boolean",
    ...l(t)
  });
}
function Tr(e) {
  return new e({
    type: "unknown"
  });
}
function Pr(e, t) {
  return new e({
    type: "never",
    ...l(t)
  });
}
function Ze(e, t) {
  return new Ve({
    check: "less_than",
    ...l(t),
    value: e,
    inclusive: !1
  });
}
function Q(e, t) {
  return new Ve({
    check: "less_than",
    ...l(t),
    value: e,
    inclusive: !0
  });
}
function ke(e, t) {
  return new We({
    check: "greater_than",
    ...l(t),
    value: e,
    inclusive: !1
  });
}
function ee(e, t) {
  return new We({
    check: "greater_than",
    ...l(t),
    value: e,
    inclusive: !0
  });
}
function $e(e, t) {
  return new Bt({
    check: "multiple_of",
    ...l(t),
    value: e
  });
}
function Ke(e, t) {
  return new Kt({
    check: "max_length",
    ...l(t),
    maximum: e
  });
}
function K(e, t) {
  return new Jt({
    check: "min_length",
    ...l(t),
    minimum: e
  });
}
function Je(e, t) {
  return new Yt({
    check: "length_equals",
    ...l(t),
    length: e
  });
}
function Or(e, t) {
  return new Xt({
    check: "string_format",
    format: "regex",
    ...l(t),
    pattern: e
  });
}
function Sr(e) {
  return new qt({
    check: "string_format",
    format: "lowercase",
    ...l(e)
  });
}
function Ar(e) {
  return new Ht({
    check: "string_format",
    format: "uppercase",
    ...l(e)
  });
}
function Nr(e, t) {
  return new Qt({
    check: "string_format",
    format: "includes",
    ...l(t),
    includes: e
  });
}
function Rr(e, t) {
  return new en({
    check: "string_format",
    format: "starts_with",
    ...l(t),
    prefix: e
  });
}
function xr(e, t) {
  return new tn({
    check: "string_format",
    format: "ends_with",
    ...l(t),
    suffix: e
  });
}
function U(e) {
  return new nn({
    check: "overwrite",
    tx: e
  });
}
function Cr(e) {
  return U((t) => t.normalize(e));
}
function jr() {
  return U((e) => e.trim());
}
function Dr() {
  return U((e) => e.toLowerCase());
}
function Ur() {
  return U((e) => e.toUpperCase());
}
function Fr(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...l(n)
  });
}
function Lr(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...l(n)
  });
}
const Mr = /* @__PURE__ */ c("ZodISODateTime", (e, t) => {
  vn.init(e, t), w.init(e, t);
});
function Vr(e) {
  return wr(Mr, e);
}
const Wr = /* @__PURE__ */ c("ZodISODate", (e, t) => {
  gn.init(e, t), w.init(e, t);
});
function Br(e) {
  return Zr(Wr, e);
}
const Gr = /* @__PURE__ */ c("ZodISOTime", (e, t) => {
  zn.init(e, t), w.init(e, t);
});
function Kr(e) {
  return kr(Gr, e);
}
const Jr = /* @__PURE__ */ c("ZodISODuration", (e, t) => {
  bn.init(e, t), w.init(e, t);
});
function Yr(e) {
  return $r(Jr, e);
}
const Xr = (e, t) => {
  xe.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => ft(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => pt(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => e.issues.push(n)
      // enumerable: false,
    },
    addIssues: {
      value: (n) => e.issues.push(...n)
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, q = c("ZodError", Xr, {
  Parent: Error
}), qr = /* @__PURE__ */ dt(q), Hr = /* @__PURE__ */ _t(q), Qr = /* @__PURE__ */ je(q), eo = /* @__PURE__ */ De(q), Z = /* @__PURE__ */ c("ZodType", (e, t) => (b.init(e, t), e.def = t, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(
  {
    ...t,
    checks: [
      ...t.checks ?? [],
      ...n.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
    ]
  }
  // { parent: true }
), e.clone = (n, r) => A(e, n, r), e.brand = () => e, e.register = ((n, r) => (n.add(e, r), e)), e.parse = (n, r) => qr(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => Qr(e, n, r), e.parseAsync = async (n, r) => Hr(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => eo(e, n, r), e.spa = e.safeParseAsync, e.refine = (n, r) => e.check(Xo(n, r)), e.superRefine = (n) => e.check(qo(n)), e.overwrite = (n) => e.check(U(n)), e.optional = () => Te(e), e.nullable = () => Pe(e), e.nullish = () => Te(Pe(e)), e.nonoptional = (n) => Mo(e, n), e.array = () => N(e), e.or = (n) => Po([e, n]), e.and = (n) => So(e, n), e.transform = (n) => Oe(e, Co(n)), e.default = (n) => Uo(e, n), e.prefault = (n) => Lo(e, n), e.catch = (n) => Wo(e, n), e.pipe = (n) => Oe(e, n), e.readonly = () => Ko(e), e.describe = (n) => {
  const r = e.clone();
  return W.add(r, { description: n }), r;
}, Object.defineProperty(e, "description", {
  get() {
    var n;
    return (n = W.get(e)) == null ? void 0 : n.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return W.get(e);
  const r = e.clone();
  return W.add(r, n[0]), r;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), Ye = /* @__PURE__ */ c("_ZodString", (e, t) => {
  se.init(e, t), Z.init(e, t);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...r) => e.check(Or(...r)), e.includes = (...r) => e.check(Nr(...r)), e.startsWith = (...r) => e.check(Rr(...r)), e.endsWith = (...r) => e.check(xr(...r)), e.min = (...r) => e.check(K(...r)), e.max = (...r) => e.check(Ke(...r)), e.length = (...r) => e.check(Je(...r)), e.nonempty = (...r) => e.check(K(1, ...r)), e.lowercase = (r) => e.check(Sr(r)), e.uppercase = (r) => e.check(Ar(r)), e.trim = () => e.check(jr()), e.normalize = (...r) => e.check(Cr(...r)), e.toLowerCase = () => e.check(Dr()), e.toUpperCase = () => e.check(Ur());
}), to = /* @__PURE__ */ c("ZodString", (e, t) => {
  se.init(e, t), Ye.init(e, t), e.email = (n) => e.check(er(no, n)), e.url = (n) => e.check(ur(ro, n)), e.jwt = (n) => e.check(br(zo, n)), e.emoji = (n) => e.check(ir(oo, n)), e.guid = (n) => e.check(we(ye, n)), e.uuid = (n) => e.check(tr(B, n)), e.uuidv4 = (n) => e.check(nr(B, n)), e.uuidv6 = (n) => e.check(rr(B, n)), e.uuidv7 = (n) => e.check(or(B, n)), e.nanoid = (n) => e.check(cr(uo, n)), e.guid = (n) => e.check(we(ye, n)), e.cuid = (n) => e.check(sr(io, n)), e.cuid2 = (n) => e.check(ar(co, n)), e.ulid = (n) => e.check(lr(so, n)), e.base64 = (n) => e.check(vr(mo, n)), e.base64url = (n) => e.check(gr(vo, n)), e.xid = (n) => e.check(hr(ao, n)), e.ksuid = (n) => e.check(pr(lo, n)), e.ipv4 = (n) => e.check(fr(ho, n)), e.ipv6 = (n) => e.check(dr(po, n)), e.cidrv4 = (n) => e.check(_r(fo, n)), e.cidrv6 = (n) => e.check(mr(_o, n)), e.e164 = (n) => e.check(zr(go, n)), e.datetime = (n) => e.check(Vr(n)), e.date = (n) => e.check(Br(n)), e.time = (n) => e.check(Kr(n)), e.duration = (n) => e.check(Yr(n));
});
function d(e) {
  return Qn(to, e);
}
const w = /* @__PURE__ */ c("ZodStringFormat", (e, t) => {
  g.init(e, t), Ye.init(e, t);
}), no = /* @__PURE__ */ c("ZodEmail", (e, t) => {
  sn.init(e, t), w.init(e, t);
}), ye = /* @__PURE__ */ c("ZodGUID", (e, t) => {
  un.init(e, t), w.init(e, t);
}), B = /* @__PURE__ */ c("ZodUUID", (e, t) => {
  cn.init(e, t), w.init(e, t);
}), ro = /* @__PURE__ */ c("ZodURL", (e, t) => {
  an.init(e, t), w.init(e, t);
}), oo = /* @__PURE__ */ c("ZodEmoji", (e, t) => {
  ln.init(e, t), w.init(e, t);
}), uo = /* @__PURE__ */ c("ZodNanoID", (e, t) => {
  hn.init(e, t), w.init(e, t);
}), io = /* @__PURE__ */ c("ZodCUID", (e, t) => {
  pn.init(e, t), w.init(e, t);
}), co = /* @__PURE__ */ c("ZodCUID2", (e, t) => {
  fn.init(e, t), w.init(e, t);
}), so = /* @__PURE__ */ c("ZodULID", (e, t) => {
  dn.init(e, t), w.init(e, t);
}), ao = /* @__PURE__ */ c("ZodXID", (e, t) => {
  _n.init(e, t), w.init(e, t);
}), lo = /* @__PURE__ */ c("ZodKSUID", (e, t) => {
  mn.init(e, t), w.init(e, t);
}), ho = /* @__PURE__ */ c("ZodIPv4", (e, t) => {
  wn.init(e, t), w.init(e, t);
}), po = /* @__PURE__ */ c("ZodIPv6", (e, t) => {
  Zn.init(e, t), w.init(e, t);
}), fo = /* @__PURE__ */ c("ZodCIDRv4", (e, t) => {
  kn.init(e, t), w.init(e, t);
}), _o = /* @__PURE__ */ c("ZodCIDRv6", (e, t) => {
  $n.init(e, t), w.init(e, t);
}), mo = /* @__PURE__ */ c("ZodBase64", (e, t) => {
  yn.init(e, t), w.init(e, t);
}), vo = /* @__PURE__ */ c("ZodBase64URL", (e, t) => {
  En.init(e, t), w.init(e, t);
}), go = /* @__PURE__ */ c("ZodE164", (e, t) => {
  Tn.init(e, t), w.init(e, t);
}), zo = /* @__PURE__ */ c("ZodJWT", (e, t) => {
  On.init(e, t), w.init(e, t);
}), Xe = /* @__PURE__ */ c("ZodNumber", (e, t) => {
  Ge.init(e, t), Z.init(e, t), e.gt = (r, o) => e.check(ke(r, o)), e.gte = (r, o) => e.check(ee(r, o)), e.min = (r, o) => e.check(ee(r, o)), e.lt = (r, o) => e.check(Ze(r, o)), e.lte = (r, o) => e.check(Q(r, o)), e.max = (r, o) => e.check(Q(r, o)), e.int = (r) => e.check(Ie(r)), e.safe = (r) => e.check(Ie(r)), e.positive = (r) => e.check(ke(0, r)), e.nonnegative = (r) => e.check(ee(0, r)), e.negative = (r) => e.check(Ze(0, r)), e.nonpositive = (r) => e.check(Q(0, r)), e.multipleOf = (r, o) => e.check($e(r, o)), e.step = (r, o) => e.check($e(r, o)), e.finite = () => e;
  const n = e._zod.bag;
  e.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), e.isFinite = !0, e.format = n.format ?? null;
});
function bo(e) {
  return yr(Xe, e);
}
const wo = /* @__PURE__ */ c("ZodNumberFormat", (e, t) => {
  Sn.init(e, t), Xe.init(e, t);
});
function Ie(e) {
  return Ir(wo, e);
}
const Zo = /* @__PURE__ */ c("ZodBoolean", (e, t) => {
  An.init(e, t), Z.init(e, t);
});
function J(e) {
  return Er(Zo, e);
}
const ko = /* @__PURE__ */ c("ZodUnknown", (e, t) => {
  Nn.init(e, t), Z.init(e, t);
});
function Ee() {
  return Tr(ko);
}
const $o = /* @__PURE__ */ c("ZodNever", (e, t) => {
  Rn.init(e, t), Z.init(e, t);
});
function yo(e) {
  return Pr($o, e);
}
const Io = /* @__PURE__ */ c("ZodArray", (e, t) => {
  xn.init(e, t), Z.init(e, t), e.element = t.element, e.min = (n, r) => e.check(K(n, r)), e.nonempty = (n) => e.check(K(1, n)), e.max = (n, r) => e.check(Ke(n, r)), e.length = (n, r) => e.check(Je(n, r)), e.unwrap = () => e.element;
});
function N(e, t) {
  return Fr(Io, e, t);
}
const Eo = /* @__PURE__ */ c("ZodObject", (e, t) => {
  Cn.init(e, t), Z.init(e, t), v(e, "shape", () => t.shape), e.keyof = () => Ro(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Ee() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Ee() }), e.strict = () => e.clone({ ...e._zod.def, catchall: yo() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => st(e, n), e.merge = (n) => at(e, n), e.pick = (n) => it(e, n), e.omit = (n) => ct(e, n), e.partial = (...n) => lt(qe, e, n[0]), e.required = (...n) => ht(He, e, n[0]);
});
function T(e, t) {
  const n = {
    type: "object",
    get shape() {
      return ie(this, "shape", { ...e }), this.shape;
    },
    ...l(t)
  };
  return new Eo(n);
}
const To = /* @__PURE__ */ c("ZodUnion", (e, t) => {
  jn.init(e, t), Z.init(e, t), e.options = t.options;
});
function Po(e, t) {
  return new To({
    type: "union",
    options: e,
    ...l(t)
  });
}
const Oo = /* @__PURE__ */ c("ZodIntersection", (e, t) => {
  Dn.init(e, t), Z.init(e, t);
});
function So(e, t) {
  return new Oo({
    type: "intersection",
    left: e,
    right: t
  });
}
const Ao = /* @__PURE__ */ c("ZodRecord", (e, t) => {
  Un.init(e, t), Z.init(e, t), e.keyType = t.keyType, e.valueType = t.valueType;
});
function No(e, t, n) {
  return new Ao({
    type: "record",
    keyType: e,
    valueType: t,
    ...l(n)
  });
}
const re = /* @__PURE__ */ c("ZodEnum", (e, t) => {
  Fn.init(e, t), Z.init(e, t), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, o) => {
    const u = {};
    for (const i of r)
      if (n.has(i))
        u[i] = t.entries[i];
      else
        throw new Error(`Key ${i} not found in enum`);
    return new re({
      ...t,
      checks: [],
      ...l(o),
      entries: u
    });
  }, e.exclude = (r, o) => {
    const u = { ...t.entries };
    for (const i of r)
      if (n.has(i))
        delete u[i];
      else
        throw new Error(`Key ${i} not found in enum`);
    return new re({
      ...t,
      checks: [],
      ...l(o),
      entries: u
    });
  };
});
function Ro(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new re({
    type: "enum",
    entries: n,
    ...l(t)
  });
}
const xo = /* @__PURE__ */ c("ZodTransform", (e, t) => {
  Ln.init(e, t), Z.init(e, t), e._zod.parse = (n, r) => {
    n.addIssue = (u) => {
      if (typeof u == "string")
        n.issues.push(D(u, n.value, t));
      else {
        const i = u;
        i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = n.value), i.inst ?? (i.inst = e), i.continue ?? (i.continue = !0), n.issues.push(D(i));
      }
    };
    const o = t.transform(n.value, n);
    return o instanceof Promise ? o.then((u) => (n.value = u, n)) : (n.value = o, n);
  };
});
function Co(e) {
  return new xo({
    type: "transform",
    transform: e
  });
}
const qe = /* @__PURE__ */ c("ZodOptional", (e, t) => {
  Mn.init(e, t), Z.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Te(e) {
  return new qe({
    type: "optional",
    innerType: e
  });
}
const jo = /* @__PURE__ */ c("ZodNullable", (e, t) => {
  Vn.init(e, t), Z.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Pe(e) {
  return new jo({
    type: "nullable",
    innerType: e
  });
}
const Do = /* @__PURE__ */ c("ZodDefault", (e, t) => {
  Wn.init(e, t), Z.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Uo(e, t) {
  return new Do({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : t;
    }
  });
}
const Fo = /* @__PURE__ */ c("ZodPrefault", (e, t) => {
  Bn.init(e, t), Z.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Lo(e, t) {
  return new Fo({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : t;
    }
  });
}
const He = /* @__PURE__ */ c("ZodNonOptional", (e, t) => {
  Gn.init(e, t), Z.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Mo(e, t) {
  return new He({
    type: "nonoptional",
    innerType: e,
    ...l(t)
  });
}
const Vo = /* @__PURE__ */ c("ZodCatch", (e, t) => {
  Kn.init(e, t), Z.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Wo(e, t) {
  return new Vo({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const Bo = /* @__PURE__ */ c("ZodPipe", (e, t) => {
  Jn.init(e, t), Z.init(e, t), e.in = t.in, e.out = t.out;
});
function Oe(e, t) {
  return new Bo({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const Go = /* @__PURE__ */ c("ZodReadonly", (e, t) => {
  Yn.init(e, t), Z.init(e, t);
});
function Ko(e) {
  return new Go({
    type: "readonly",
    innerType: e
  });
}
const Jo = /* @__PURE__ */ c("ZodCustom", (e, t) => {
  Xn.init(e, t), Z.init(e, t);
});
function Yo(e) {
  const t = new I({
    check: "custom"
    // ...util.normalizeParams(params),
  });
  return t._zod.check = e, t;
}
function Xo(e, t = {}) {
  return Lr(Jo, e, t);
}
function qo(e) {
  const t = Yo((n) => (n.addIssue = (r) => {
    if (typeof r == "string")
      n.issues.push(D(r, n.value, t._zod.def));
    else {
      const o = r;
      o.fatal && (o.continue = !1), o.code ?? (o.code = "custom"), o.input ?? (o.input = n.value), o.inst ?? (o.inst = t), o.continue ?? (o.continue = !t._zod.def.abort), n.issues.push(D(o));
    }
  }, e(n.value, n)));
  return t;
}
const Ho = T({
  value: d(),
  label: d(),
  hierarchical: J(),
  publicly_queryable: J()
}), Qo = T({
  countries: No(d(), d()),
  currency: T({
    slug: d(),
    symbol: d()
  }),
  product_taxonomies: N(Ho),
  notify_low_stock_amount: bo(),
  dimension_unit: d(),
  weight_unit: d(),
  permalinks: T({
    product_base: d(),
    category_base: d(),
    tag_base: d(),
    attribute_base: d(),
    use_verbose_page_rules: J(),
    product_rewrite_slug: d(),
    category_rewrite_slug: d(),
    tag_rewrite_slug: d(),
    attribute_rewrite_slug: d()
  }),
  manage_stock: J(),
  product_types: N(T({
    value: d(),
    label: d(),
    color: d()
  })),
  order_statuses: N(T({
    value: d(),
    label: d(),
    color: d()
  })),
  post_statuses: N(T({
    value: d(),
    label: d(),
    color: d()
  })),
  product_stock_statuses: N(T({
    value: d(),
    label: d(),
    color: d()
  }))
}), eu = {
  countries: {},
  currency: {
    slug: "",
    symbol: ""
  },
  product_taxonomies: [],
  notify_low_stock_amount: 0,
  dimension_unit: "",
  weight_unit: "",
  permalinks: {
    product_base: "",
    category_base: "",
    tag_base: "",
    attribute_base: "",
    use_verbose_page_rules: !1,
    product_rewrite_slug: "",
    category_rewrite_slug: "",
    tag_rewrite_slug: "",
    attribute_rewrite_slug: ""
  },
  manage_stock: !0,
  product_types: [],
  order_statuses: [],
  post_statuses: [],
  product_stock_statuses: []
};
export {
  eu as DEFAULT_WOOCOMMERCE,
  Ho as TaxonomySchema,
  Qo as WoocommerceSchema
};
